import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512,192 L512,320 L361.856,320 C297.216,320 242.688,368.256 234.752,432.256 C218.624,541.696 188.8,750.72 164.736,935.808 C242.176,871.936 340.096,832 448,832 C695.04,832 896,1032.96 896,1280 L895.948,1273.694 L895.9488,1216.0512 L1030.4768,1216.0512 C1061.8368,999.4752 1246.9248,832.0512 1471.9488,832.0512 C1582.5408,832.0512 1682.5088,873.7792 1760.8448,940.3392 C1737.4208,754.3552 1708.2368,543.2832 1692.6208,433.8432 C1684.8128,368.3072 1631.6928,320.0512 1569.1008,320.0512 L1569.1008,320.0512 L1407.9488,320.0512 L1407.9488,192.0512 L1569.1008,192.0512 C1694.4128,192.0512 1800.2688,288.6912 1815.5008,416.6912 C1819.5968,445.1072 1918.7968,1148.8512 1918.7968,1280.0512 C1918.7968,1526.9632 1718.9888,1728.0512 1471.9488,1728.0512 C1246.9248,1728.0512 1061.8368,1560.4992 1030.4768,1344.0512 L1030.4768,1344.0512 L895.9488,1344.0512 L895.95628,1286.30796 C892.570252,1530.45179 692.933965,1728 448,1728 C200.96,1728 0,1527.04 0,1280 C0,1148.8 103.552,445.056 107.904,415.232 C123.392,288.64 232.704,192 361.856,192 L361.856,192 L512,192 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStudentViewSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconStudentViewSolid, _Component);

  var _super = _createSuper(IconStudentViewSolid);

  function IconStudentViewSolid() {
    _classCallCheck(this, IconStudentViewSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconStudentViewSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStudentView",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStudentViewSolid.displayName = "IconStudentViewSolid";
  return IconStudentViewSolid;
}(Component);

IconStudentViewSolid.glyphName = 'student-view';
IconStudentViewSolid.variant = 'Solid';
IconStudentViewSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStudentViewSolid;
export { IconStudentViewSolid };